import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./BestMusicDistribution.css";
import { Link } from "react-router-dom";
import BannerStrip from "../Home/Hero/BannerStrip";
import RightChoice from "../Home/ExploreAlbum/RightChoice";
import Testimonial from "../Home/Testimonial/Testi/Testimonial";




const BestMusicDistribution = () => {
  return (
    <div className="bestMusicDistribution">

      {/* HERO */}
      <div className="distributionHero">
        <Container>
          <h1>Best Music Distribution Services in India</h1>
          <p>
            FT Tunes is recognized as one of the best music distribution services in India, offering artists a powerful
            platform to release and promote their music across major streaming services. With a seamless upload
            process and fast delivery, FT Tunes ensures your songs reach platforms like Spotify, Apple Music and more
            without delays. The platform is designed to support artists at every level, helping them grow their audience
            and build a strong digital presence.
          </p>
                          <div className="button-container_buttonContainer__YRgZl button-container_center__H3vVZ">
                          <a
                            href="https://dashboard.fttunes.com/register.php"
                            className="button_button__MFmXH button_color__bLscP"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            DISTRIBUTE MY MUSIC ONLINE
                          </a>
                          </div>
        </Container>
      </div>

      <Container className="distributionContent">

        <Row className="g-4">

          <Col md={6}>
            <div className="contentCard">
              <h2>Top Music Distribution Company in India for Artists</h2>
              <p>
                As a top music distribution company in India for artists, FT Tunes focuses on providing reliable and
                professional services. Artists get access to advanced tools for tracking performance, managing releases and
                monitoring royalties. The platform ensures that every track is delivered with accuracy, helping artists
                maintain their credibility and professionalism in the music industry.
              </p>
            </div>
          </Col>

          <Col md={6}>
            <div className="contentCard">
              <h2>Music Distribution Services for Independent Artists in India</h2>
              <p>
                FT Tunes specializes in offering music distribution services for independent artists in India, giving creators full
                control over their music. Independent artists can easily upload their tracks, manage releases and distribute
                their content globally without the need for a record label. This allows artists to retain ownership and maximize
                the earnings while reaching a wider audience.
              </p>
            </div>
          </Col>

          <Col md={6}>
            <div className="contentCard">
              <h2>Online Music Distribution Company in India for Beginners</h2>
              <p>
                For newcomers, FT Tunes serves as an ideal online music distribution company in India for beginners. The
                platform features a simple and user-friendly interface that makes it easy for first-time users to release their
                music. From uploading songs to adding metadata, everything is streamlined so beginners can focus on their
                creativity rather than technical complexities.
              </p>
            </div>
          </Col>

          <Col md={6}>
            <div className="contentCard">
              <h2>Indian Music Distribution Platform with Global Reach</h2>
              <p>
                FT Tunes stands out as an Indian music distribution platform with global reach, connecting artists to listeners
                worldwide. By distributing music to international platforms, FT Tunes helps artists expand beyond local
                audiences and build a global fan base. This worldwide exposure plays a crucial role in growing an artist’s
                brand and increasing recognition.
              </p>
            </div>
          </Col>

          <Col md={6}>
            <div className="contentCard">
              <h2>Affordable Music Distribution Services in India</h2>
              <p>
                One of the key advantages of FT Tunes is its affordable music distribution services in India. The platform offers
                cost-effective plans that suit both new and established artists. With transparent pricing and no hidden
                charges, FT Tunes ensures that artists can distribute the music without financial stress, making it accessible
                for everyone.
              </p>
            </div>
          </Col>

          <Col md={6}>
            <div className="contentCard">
              <h2>Music Distribution Services in India</h2>
              <p>
                When it comes to dependable music distribution services in India, FT Tunes is a trusted choice. The platform
                combines advanced technology with artist focused features to deliver a smooth distribution experience.
              </p>

              <p>
                Whether you are launching your first track or managing multiple releases, FT Tunes provides the tools and
                support needed to succeed in today’s competitive music industry.
              </p>
            </div>
          </Col>

        </Row>

      </Container>
      <BannerStrip />
      <RightChoice />
      <Testimonial />


    </div>
  );
};

export default BestMusicDistribution;